import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a URL ensuring it has the correct protocol and no trailing slashes
 */
export function formatApiUrl(url: string): string {
  // Add http:// if no protocol is specified
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = `http://${url}`;
  }
  
  // Remove trailing slash if present
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

/**
 * Tests if a GraphQL endpoint is reachable
 */
export async function testGraphQLConnection(url: string): Promise<{ success: boolean; message: string }> {
  try {
    const response = await fetch(formatApiUrl(url), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: '{ __schema { queryType { name } } }',
      }),
    });
    
    if (!response.ok) {
      return { 
        success: false, 
        message: `Server responded with status: ${response.status}` 
      };
    }
    
    const data = await response.json();
    return { 
      success: true, 
      message: 'GraphQL server is reachable' 
    };
  } catch (error) {
    return { 
      success: false, 
      message: `Connection error: ${error instanceof Error ? error.message : String(error)}` 
    };
  }
}

/**
 * Logs detailed information about API requests for debugging
 */
export function logApiRequest(url: string, method: string, headers?: Record<string, string>, body?: any): void {
  console.group('API Request Details');
  console.log('URL:', url);
  console.log('Method:', method);
  console.log('Headers:', headers || 'None');
  console.log('Body:', body || 'None');
  console.groupEnd();
}
